import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const QueensUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Queen's University"
      universityShortName="Queen's"
      slug="queens-university"
      seoTitle="Queen's University Study Rooms | Kingston Campus Study Guide"
      seoDescription="Complete guide to study rooms at Queen's University. Find Stauffer Library, Bracken Library, and unique study spaces. Plus free 24/7 online alternative."
      seoKeywords="queens university study rooms, queens library, stauffer library, bracken library, kingston university study spaces"
      canonicalUrl="/study-room/queens-university/"
      heroDescription="A comprehensive guide to study rooms at Queen's, including Stauffer Library, Bracken Health Sciences Library, and alternative spaces."
      libraryWebsiteUrl="https://library.queensu.ca/"
      libraryWebsiteName="Queen's Library"
      studySpaces={[
        {
          name: "Stauffer Library",
          features: "Main study hub with group rooms equipped with chalkboards.",
          feedback: "Often busy; group rooms are pleasant though chalkboards can be messy."
        },
        {
          name: "Bracken Health Sciences Library",
          features: "Dead-silent environment with floor-to-ceiling windows, hanging plants, and study rooms with TVs and whiteboards.",
          feedback: "Adored for its serene vibe; highly recommended for focused study."
        },
        {
          name: "Common Ground Coffeehouse",
          features: "Campus café with light chatter and good bagels.",
          feedback: "Loved for atmosphere but not ideal for high-focus work."
        },
        {
          name: "Breakwater Park",
          features: "Outdoor picnic tables on Lake Ontario.",
          feedback: "Great when weather permits but has limited Wi-Fi."
        },
        {
          name: "Law Library",
          features: "Spacious tables encouraging productivity.",
          feedback: "Lacks views and is far from main classes but great for focused work."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Visit <strong>Bracken</strong> for concentrated study or <strong>Stauffer early in the morning</strong>. For group brainstorming, try the <strong>Law Library's long tables</strong>.
          </p>
          <p className="mb-4">
            If you need a mental break, head to <strong>Breakwater Park</strong> for fresh air and a scenic change of pace.
          </p>
          <p>
            Students often lament Stauffer's crowds and chalk dust, but adore Bracken's serene vibe with its floor-to-ceiling windows and hanging plants.
          </p>
        </>
      }
      summaryTips={[
        "Visit Bracken for peace: Floor-to-ceiling windows, hanging plants, and dead silence.",
        "Arrive at Stauffer early: Gets crowded quickly; morning offers best availability.",
        "Use Law Library for focus: Spacious tables encourage productivity.",
        "Try Breakwater Park: Lake Ontario views for a mental refresh (weather permitting).",
        "Use CSW for guaranteed quiet: Virtual study rooms when Stauffer is crowded."
      ]}
    />
  );
};

export default QueensUniversity;
